module.exports = __webpack_public_path__ + "static/img/partner-logo11.0dda5cf2.jpg";